/* global app util user */
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
};

function createAPI(window) {
  const Cookie = window.Cookie;
  const Store = window.Store;
  const fetch = window.fetch;
  const qs = window.qs;
  const _ = window._;
  const $ = window.$;
  const createError = window.createError;

  const api = {};
  let jwt;
  let headers;

  function updateJWTToken() {
    jwt = Store.get('jwt');
    const auth_headers = jwt ? {
      Authorization: 'Bearer ' + jwt
    } : {};
    headers = _.merge({}, DEFAULT_HEADERS, auth_headers);
    if (!jwt) delete headers.Authorization;
    $.ajaxSetup({ headers: auth_headers });
  }
  updateJWTToken();


  function normalize_user(item) {
    return _.merge({}, item);
  }

  function normalize_question(item) {
    return _.merge({
      photos: [],
      assigned_department: null,
      assigned_users: [],
      categories: [],
      tags: [],
      comments: [],
      progresses: [],
      merge_children_pins: []
    }, item);
  }

  function normalize_news(item) {
    return _.merge({
      categories: [],
      tags: []
    }, item);
  }

  function normalize_announcement(item) {
    return _.merge({
      categories: [],
      tags: []
    }, item);
  }

  function normalize_resource(item) {
    return _.merge({
      categories: [],
      tags: []
    }, item);
  }

  api._buildEndpoint = function (path, queryParams) {
    return app.config.api_url + '/' + path + '?' + qs.stringify(queryParams, { encode: false });
  };

  api._buildBaseURLEndpoint = function (path, queryParams) {
    return app.config.baseurl + '/' + path + '?' + qs.stringify(queryParams, { encode: false });
  };

  api.loginUser = (login_data) => {
    const url = api._buildEndpoint('auth/login');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(login_data),
      headers: _.merge({}, headers, {
        Accept: 'application/json'
      })
    })
    .then(response => response.json());
  };

  api.forgetpassword = (login_data) => {
    const url = api._buildEndpoint('auth/login/forgetpassword');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(login_data),
      headers: _.merge({}, headers, {
        Accept: 'application/json'
      })
    })
    .then(response => response.json());
  };

  api.refreshToken = (id) => {
    const url = api._buildEndpoint('auth/jwt/refresh');
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json())
    .then(result => {
      if (!result || !result.jwt) return null;
      Cookie.set(app.config.jwt.cookie_name, result.jwt);
      Store.set('jwt', result.jwt, new Date().getTime() + app.config.jwt.maxage);
      updateJWTToken();
      return api.storeSessionToken(result.jwt)
      .then(sess_result => result.jwt);
    });
  };

  api.storeSessionToken = (token) => {
    const url = api._buildBaseURLEndpoint('auth/jwt', { jwt: token });
    return fetch(url, {
      mode: 'cors',
      headers: _.merge({}, headers, {
        Accept: 'application/json'
      })
    })
    .then(response => response.json());
  };

  api.getSummary = (start, end, cb) => {
    const url = api._buildEndpoint(
      'summarize-states', {
        start_date: start,
        end_date: end
      }
    );
    return fetch(url, {
      headers: headers
    })
    .then(response => response.json())
    .then(cb);
  };

  api.getRecentActivities = (cb) => {
    let opts = {
      $sort: '-timestamp',
      $limit: 30
    };

    // Admin can see all activities from every department
    if (!util.check_permission('supervisor', user.role)) {
      opts = _.extend(opts, {
        department: user.department
      });
    }

    const url = api._buildEndpoint('activity_logs', opts);
    return fetch(url, {
      headers: headers
    })
    .then(response => response.json()).then(cb);
  };

  api.getDepartments = (opts = {}) => {
    const default_opts = {
      $limit: 100
    };
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('departments', opts);
    return fetch(url)
    .then(response => response.json());
  };

  api.createDepartment = (deptName) => {
    const body = {
      name: deptName,
    };

    const url = api._buildEndpoint('departments');
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.updateDepartment = (deptId, patchObj) => {
    const url = api._buildEndpoint('departments/' + deptId);
    return fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(patchObj),
      headers: headers
    });
  };

  api.postTransition = (pinId, body) => {
    const url = api._buildEndpoint('questions/' + pinId + '/state_transition');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(body),
      headers: headers
    })
    .then(resp => resp && resp.ok && resp.json());
  };

  api.uploadFile = (formData) => {
    const url = api._buildEndpoint('files');
    return fetch(url, {
      method: 'POST',
      body: formData,
      // Content-Type must not be set.
      // so that fetch() will automatically set multipart and boundary
      headers: _.assign({}, _.omit(headers, ['Content-Type']))
    });
  };

  api.getUsers = (opts) => {
    const default_opts = {
      $limit: 20
    };
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('persons', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.getUser = (id) => {
    const url = api._buildEndpoint('persons/' + id);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.createUser = (userObj) => {
    const url = api._buildEndpoint('persons');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(userObj),
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_user(item))
    .then(item => {
      // Important: Save login session on browser!
      // Because we login through API call,
      // session token store must be initiated on client side
      Cookie.set(app.config.jwt.cookie_name, item.jwt);
      Store.set('jwt', item.jwt, new Date().getTime() + app.config.jwt.maxage);
      return api.storeSessionToken(item.jwt)
      .then(sess_result => item);
    });
  };

  api.updateUser = (userId, patchObj) => {
    const url = api._buildEndpoint('persons/' + userId);
    return fetch(url, {
      mode: 'cors',
      method: 'PATCH',
      body: JSON.stringify(patchObj),
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_user(item))
    .then(item => {
      if (item._id === user._id) {
        return api.refreshToken().then(token => item);
      }
      return item;
    });
  };

  api.removeUser = (id) => {
    const url = api._buildEndpoint('persons/' + id);
    return fetch(url, {
      mode: 'cors',
      method: 'DELETE',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_user(item));
  };


  api.createPin = (pinObj) => {
    const url = api._buildEndpoint('questions');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(pinObj),
      headers: headers
    })
    .catch(err => console.log('create pin err:', err))
    .then(response => response.json())
    .then(data => {
      if (data.code >= 400) {
        data.message = data.message + ' ' + _.map(data.errors, 'message').join('\n');
        throw createError(data.code, data);
      }
      return data;
    });
  };

  api.getQuestion = (id) => {
    const url = api._buildEndpoint('questions/' + id);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_question(item));
  };

  api.findQuestion = (query) => {
    const queryOpts = _.extend({
      // _sort: '-created_time',
      // _limit: 20
    }, query);

    const url = api._buildEndpoint('questions', queryOpts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.patchPin = (id, body) => {
    const url = api._buildEndpoint('questions/' + id);
    return fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.patchPinParam = (id, param) => {
    const url = api._buildEndpoint('questions/' + id, param);
    return fetch(url, {
      method: 'PATCH',
      headers: headers
    });
  };

  api.mergePins = (child_id, parent_id) => {
    const body = {
      mergedParentPin: parent_id,
    };

    const url = api._buildEndpoint('questions/' + child_id + '/merging');
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.getQuestionActivities = (id) => {
    const opts = {
      question_id: id,
      $sort: '-timestamp',
      $limit: 50
    };

    const url = api._buildEndpoint('activity_logs', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.removeQuestion = (id) => {
    const url = api._buildEndpoint('questions/' + id);
    return fetch(url, {
      mode: 'cors',
      method: 'DELETE',
      headers: headers
    })
      .then(response => response.json())
      .then(item => normalize_question(item));
  };

  // 1. {{host}}/pins?updated_time[$gte]=2017-01-09&updated_time[$lte]=2017-01-15&status=resolved
  // 2. {{host}}/pins?created_time[$lte]=2017-01-09&status[$in]=pending&status[$in]=assigned&status[$in]=processing
  // 3. {{host}}/pins?created_time[$gte]=2017-01-09&created_time[$lte]=2017-01-15&status[$in]=pending&status[$in]=assigned&status[$in]=processing
  // api.getPerformance = (input_date, duration = 7, department) => {
  api.getPerformance = (query_start_date, query_end_date, options = {}) => {
    // const end_date = moment(input_date).add(1, 'days').format('YYYY-MM-DD');
    // const start_date = moment(input_date).subtract(duration, 'days').format('YYYY-MM-DD');
    let current_resolved_pin = 0;
    let current_rejected_pin = 0;
    let current_new_pins = 0;
    let prev_active_pins = 0;
    let queryOpts = {};
    if (options.department) {
      queryOpts = {
        assigned_department: {
          $in: options.department.split(',')
        }
      };
    }
    if (options.category) {
      queryOpts = {
        categories: {
          $in: options.category.split(',')
        }
      };
    }

    // 1. current_resolved_pin
    function get_current_resolved_pin(start_date, end_date, queryOpts) {
      const opts = _.extend(queryOpts, {
        updated_time: {
          $gte: start_date,
          $lte: end_date,
        },
        status: 'resolved'
      });
      const url = api._buildEndpoint('pins', opts);
      return fetch(url, {
        headers: headers
      })
      .then(response => response.json())
      .then(result => {
        current_resolved_pin = _.get(result, 'total', 0);
        return result;
      });
    }
    // 1. current_rejected_pin
    function get_current_rejected_pin(start_date, end_date, queryOpts) {
      const opts = _.extend(queryOpts, {
        updated_time: {
          $gte: start_date,
          $lte: end_date,
        },
        status: 'rejected'
      });
      const url = api._buildEndpoint('pins', opts);
      return fetch(url, {
        headers: headers
      })
      .then(response => response.json())
      .then(result => {
        current_rejected_pin = _.get(result, 'total', 0);
        return result;
      });
    }
    // 2. prev_active_pins
    function get_prev_active_pins(start_date, queryOpts) {
      const opts = _.extend(queryOpts, {
        created_time: {
          $lte: start_date,
        },
        status: {
          $in: ['pending', 'assigned', 'processing']
        }
      });
      const url = api._buildEndpoint('pins', opts);
      return fetch(url, {
        headers: headers
      })
      .then(response => response.json())
      .then(result => {
        prev_active_pins = _.get(result, 'total', 0);
        return result;
      });
    }
    // 3. current_new_pins
    function get_current_new_pins(start_date, end_date, queryOpts) {
      const opts = _.extend(queryOpts, {
        created_time: {
          $gte: start_date,
          $lte: end_date,
        },
        status: {
          $in: ['pending', 'assigned', 'processing']
        }
      });
      const url = api._buildEndpoint('pins', opts);
      return fetch(url, {
        headers: headers
      })
      .then(response => response.json())
      .then(result => {
        current_new_pins = _.get(result, 'total', 0);
        return result;
      });
    }

    return Promise.resolve({})
    .then(() => get_current_resolved_pin(query_start_date, query_end_date, queryOpts))
    .then(() => get_current_rejected_pin(query_start_date, query_end_date, queryOpts))
    .then(() => get_prev_active_pins(query_start_date, queryOpts))
    .then(() => get_current_new_pins(query_start_date, query_end_date, queryOpts))
    .then(() => ({
      current_resolved_pin,
      current_rejected_pin,
      prev_active_pins,
      current_new_pins
    }));
  };

  // News API
  api.getNews = (id) => {
    const url = api._buildEndpoint('news/' + id);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json())
      .then(item => normalize_news(item));
  };

  api.findNews = (opts) => {
    const default_opts = {
      $limit: 20
    };
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('news', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.patchNews = (id, body) => {
    const url = api._buildEndpoint('news/' + id);
    return fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.createNews = (pinObj) => {
    const url = api._buildEndpoint('news');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(pinObj),
      headers: headers
    })
    .catch(err => console.log('create news err:', err))
    .then(response => response.json())
    .then(data => {
      if (data.code >= 400) {
        data.message = data.message + ' ' + _.map(data.errors, 'message').join('\n');
        throw createError(data.code, data);
      }
      return data;
    });
  };

  api.removeNews = (id) => {
    const url = api._buildEndpoint('news/' + id);
    return fetch(url, {
      mode: 'cors',
      method: 'DELETE',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_news(item));
  };

  // Announcement API
  api.getAnnouncement = (id) => {
    const url = api._buildEndpoint('announcement/' + id);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_announcement(item));
  };

  api.findAnnouncement = (opts) => {
    const default_opts = {
      $limit: 20
    };
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('announcement', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.patchAnnouncement = (id, body) => {
    const url = api._buildEndpoint('announcement/' + id);
    return fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.createAnnouncement = (pinObj) => {
    const url = api._buildEndpoint('announcement');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(pinObj),
      headers: headers
    })
    .catch(err => console.log('create announcement err:', err))
    .then(response => response.json())
    .then(data => {
      if (data.code >= 400) {
        data.message = data.message + ' ' + _.map(data.errors, 'message').join('\n');
        throw createError(data.code, data);
      }
      return data;
    });
  };

  api.removeAnnouncement = (id) => {
    const url = api._buildEndpoint('announcement/' + id);
    return fetch(url, {
      mode: 'cors',
      method: 'DELETE',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_announcement(item));
  };


  // Resource Link API
  api.getResource = (id) => {
    const url = api._buildEndpoint('resource/' + id);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_resource(item));
  };

  api.findResource = (opts) => {
    const default_opts = {
      $limit: 20
    };
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('resource', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.patchResource = (id, body) => {
    const url = api._buildEndpoint('resource/' + id);
    return fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: headers
    });
  };

  api.createResource = (pinObj) => {
    const url = api._buildEndpoint('resource');
    return fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: JSON.stringify(pinObj),
      headers: headers
    })
    .catch(err => console.log('create resource err:', err))
    .then(response => response.json())
    .then(data => {
      if (data.code >= 400) {
        data.message = data.message + ' ' + _.map(data.errors, 'message').join('\n');
        throw createError(data.code, data);
      }
      return data;
    });
  };

  api.removeResource = (id) => {
    const url = api._buildEndpoint('resource/' + id);
    return fetch(url, {
      mode: 'cors',
      method: 'DELETE',
      headers: headers
    })
    .then(response => response.json())
    .then(item => normalize_resource(item));
  };

  api.search = (query) => {
    const default_opts = {
      $limit: 20
    };
    if (typeof opts === 'object') {
      query = _.extend(default_opts, query);
    }

    const url = api._buildEndpoint('search', query);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.findReportOverall = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report/overall', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json());
  };

  api.findReportQuestion = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report/question', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json());
  };

  api.findReportNews = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report_content/news', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json());
  };

  api.findReportNotification = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report_content/notification', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json());
  };

  api.findReportKnowledge = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report_content/knowledge', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json());
  };

  api.findReportUser = (opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report/user', opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  api.getReportUser = (id, opts) => {
    const default_opts = {};
    if (typeof opts === 'object') {
      opts = _.extend(default_opts, opts);
    }

    const url = api._buildEndpoint('report/user/' + id, opts);
    return fetch(url, {
      mode: 'cors',
      headers: headers
    })
    .then(response => response.json());
  };

  return api;
}

module.exports = createAPI;
